import React from 'react';

import { PageContentContainer } from '@/components/layout/PageContentContainer';
import { BrowserStorageService } from '@/services/BrowserStorage';

import styles from './InactivityLogoutPage.module.scss';

export const InactivityLogoutPage = () => {
  React.useEffect(() => {
    BrowserStorageService.loggedOutDueToInactivity.remove();
  }, []);

  return (
    <div className={styles.page}>
      <PageContentContainer className={styles.container} classes={{ wrapper: styles.wrapper }}>
        <p>You were automatically logged out for inactivity.</p>
      </PageContentContainer>
    </div>
  );
};
